/*
 * pr-gift-note.js (DEV-474)
 *
 * Drives snippets/pr-gift-note.liquid (rendered by cart-summary.liquid in
 * the cart drawer and on the cart page). Document-level delegation, so it
 * keeps working after Horizon morphs the cart.
 *
 * Saves two cart attributes through /cart/update.js:
 *   Gift order = "Yes" | ""      Gift note = message | ""
 * A note is only ever saved while the box is checked. The fields also
 * belong to #cart-form, so Check Out posts them with the cart.
 *
 * Horizon re-renders the cart by morphing it from the server's copy, which
 * resets checkbox and textarea values and can lag the shopper's typing by
 * one save. The last thing the shopper did is kept here, put back after
 * every cart update and into every gift block on the page, then saved again.
 */
(function () {
  if (window.PRGiftNote) return;

  var LIMIT = 250;
  var DEBOUNCE_MS = 400;
  var timer = null;
  var inflight = null;
  var local = null; // { on: bool, note: string } once the shopper has touched it

  function q(block, sel) { return block.querySelector(sel); }

  function paint(block, state) {
    var check = q(block, '[data-pr-gift-check]');
    var note = q(block, '[data-pr-gift-note]');
    var panel = q(block, '[data-pr-gift-panel]');
    var flag = q(block, '[data-pr-gift-flag]');
    var clear = q(block, '[data-pr-gift-clear]');
    if (!check || !note) return;
    check.checked = state.on;
    if (note.value !== state.note) note.value = state.note;
    note.disabled = !state.on;
    if (clear) clear.disabled = state.on;
    if (flag) flag.value = state.on ? 'Yes' : '';
    if (panel) panel.hidden = !state.on;
    count(block);
  }

  function paintAll(state, except) {
    document.querySelectorAll('[data-pr-gift]').forEach(function (b) {
      if (b === except) { count(b); return; }
      paint(b, state);
    });
  }

  function read(block) {
    var check = q(block, '[data-pr-gift-check]');
    var note = q(block, '[data-pr-gift-note]');
    return { on: !!(check && check.checked), note: note ? note.value.slice(0, LIMIT) : '' };
  }

  function count(block) {
    var note = q(block, '[data-pr-gift-note]');
    var out = q(block, '[data-pr-gift-count]');
    if (note && out) out.textContent = note.value.length + '/' + LIMIT;
  }

  function status(text) {
    document.querySelectorAll('[data-pr-gift-status]').forEach(function (el) {
      el.textContent = text || '';
      el.hidden = !text;
    });
  }

  function save() {
    clearTimeout(timer);
    timer = null;
    if (!local) return Promise.resolve();
    var on = local.on;
    var note = on ? local.note.replace(/\s+$/, '') : '';
    var body = JSON.stringify({ attributes: { 'Gift order': on ? 'Yes' : '', 'Gift note': note } });
    var run = function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body
      }).then(function (r) {
        if (!r.ok) throw new Error('cart update ' + r.status);
        status('');
        return r.json();
      }).catch(function () {
        status('Your gift note did not save. Please check your connection and try again.');
      });
    };
    // Saves run one after another so an older save can never land last.
    var mine = (inflight || Promise.resolve()).then(run);
    inflight = mine;
    mine.then(function () { if (inflight === mine) inflight = null; });
    return mine;
  }

  function flush() {
    if (timer) return save();
    return inflight || Promise.resolve();
  }

  document.addEventListener('change', function (e) {
    var check = e.target.closest && e.target.closest('[data-pr-gift-check]');
    if (!check) return;
    var block = check.closest('[data-pr-gift]');
    local = read(block);
    paintAll(local);
    if (local.on) {
      var note = q(block, '[data-pr-gift-note]');
      if (note) note.focus();
    }
    save();
  });

  document.addEventListener('input', function (e) {
    var note = e.target.closest && e.target.closest('[data-pr-gift-note]');
    if (!note) return;
    var block = note.closest('[data-pr-gift]');
    if (note.value.length > LIMIT) note.value = note.value.slice(0, LIMIT);
    local = read(block);
    paintAll(local, block);
    clearTimeout(timer);
    timer = setTimeout(save, DEBOUNCE_MS);
  });

  document.addEventListener('focusout', function (e) {
    if (e.target.closest && e.target.closest('[data-pr-gift-note]') && timer) save();
  });

  // After a cart update Horizon fetches the section and morphs it, which
  // writes the server's values back into the fields. Re-apply ours once the
  // morph has landed (it is asynchronous, so check a few times).
  function reapply() {
    if (!local) return;
    document.querySelectorAll('[data-pr-gift]').forEach(function (block) {
      var shown = read(block);
      if (shown.on !== local.on || shown.note !== local.note) {
        paint(block, local);
        if (!timer) save();
      }
    });
  }
  document.addEventListener('cart:update', function () {
    [60, 300, 900, 2000].forEach(function (ms) { setTimeout(reapply, ms); });
  });

  // Put the shopper's latest state back into any re-rendered block.
  function addsGiftBlock(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches('[data-pr-gift]') || n.querySelector('[data-pr-gift]'))) return true;
      }
    }
    return false;
  }

  var observer = new MutationObserver(function (mutations) {
    if (!local || !addsGiftBlock(mutations)) return;
    document.querySelectorAll('[data-pr-gift]').forEach(function (block) {
      var shown = read(block);
      if (shown.on !== local.on || shown.note !== local.note) {
        paint(block, local);
        if (!timer) save();
      }
    });
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);

  window.PRGiftNote = { flush: flush, limit: LIMIT };
})();
